// extracted by mini-css-extract-plugin
module.exports = {"panelTitle":"panel_panelTitle__3MgDz","panelContainer":"panel_panelContainer__xknV6","children":"panel_children__1tFhd"};